import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper/modules";
import "swiper/swiper-bundle.css";
import "./Album.css";
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleLeft,faCircleRight } from "@fortawesome/free-solid-svg-icons";
const Album = () => {
  const images = [
      {
          src:"images/flower-8.png",
      },
    {
        src:"images/flower-6.png",
    },
    {
        src:"images/flower-8.png",
    },
    {
        src:"images/flower-7.png",
    },
    {
        src:"images/flower-8.png",
    }
  ]
  ;

  return (
    <div className="container album pb-5">
    <div className="text-center mb-4">
        <img src="images/Group 78.png" alt="" />
    </div>
      <div className="position-relative">
        <Swiper
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={3}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
            slideShadows: false,
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
              coverflowEffect: {}, 
            },
            768: {
              slidesPerView: 3,
              coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 2.5,
                slideShadows: false,
              },
            },
          }}
          modules={[EffectCoverflow, Navigation]}
          className="w-100"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index} className="d-flex justify-content-center">
              <div className="rounded overflow-hidden">
                <img
                  src={image.src}
                  className="img-fluid"
                  style={{width:"500px",height:"600px"}}
                  alt={`Slide ${index + 1}`}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <span className="swiper-button-prev">
          <FontAwesomeIcon icon={faCircleLeft} style={{ zIndex: 10 }} className=" secondary-color" />
        </span>
        <span className="swiper-button-next">
          <FontAwesomeIcon icon={faCircleRight} style={{ zIndex: 10 }} className=" main-color " />
        </span>
      </div>
    </div>
  );
};

export default Album;
